import { render } from "./Position.vue?vue&type=template&id=700fe15f&scoped=true"
import script from "./Position.vue?vue&type=script&lang=js"
export * from "./Position.vue?vue&type=script&lang=js"

import "./Position.vue?vue&type=style&index=0&id=700fe15f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700fe15f"]])

export default __exports__